import React from "react";
import MotionReveal from "./MotionReveal";
import HomeSectionHeading from "./HomeSectionHeading";

const trustSignals = [
  { label: "Geprüft", score: 3 },
  { label: "Lesbar", score: 3 },
  { label: "Verbindlich", score: 2 },
  { label: "Nachvollziehbar", score: 2 },
  { label: "Rollenbasiert", score: 3 },
];

export default function HomeTrustArchitecture({ content }) {
  return (
    <section className="public-home-premium__section public-home-premium__section--precision" id="trust">
      <div className="mx-auto grid w-full max-w-page gap-8 px-4 sm:px-6 lg:grid-cols-2 lg:px-8">
        <MotionReveal>
          <div className="public-home-premium__trust-intro">
            <HomeSectionHeading eyebrow={content.eyebrow} title={content.title} lead={content.lead} className="max-w-none" />
            <div className="public-home-premium__trust-aside-copy">
              <span className="public-home-premium__mini-label">Systemklarheit</span>
              <p>{content.calloutText}</p>
            </div>
          </div>
        </MotionReveal>

        <MotionReveal delay={0.08}>
          <div className="public-home-premium__trust-matrix">
            <div className="public-home-premium__trust-matrix-head">
              <span>Achse</span>
              <span>Wirkung</span>
              <span>Signal</span>
            </div>

            {(content.items || []).map((item, index) => {
              const signal = trustSignals[index] || trustSignals[trustSignals.length - 1];
              return (
                <article key={item.title} className="public-home-premium__trust-row">
                  <div className="public-home-premium__trust-row-axis">
                    <span className="public-home-premium__trust-row-order">{String(index + 1).padStart(2, "0")}</span>
                    <i aria-hidden="true" />
                    <strong>{item.title}</strong>
                  </div>
                  <p>{item.text}</p>
                  <div className="public-home-premium__trust-row-signal">
                    <span>{signal.label}</span>
                    <div className="public-home-premium__trust-markers" aria-hidden="true">
                      {[0, 1, 2].map((marker) => (
                        <i key={marker} className={marker < signal.score ? "is-active" : ""} />
                      ))}
                    </div>
                  </div>
                </article>
              );
            })}

            <div className="public-home-premium__trust-callout">
              <span className="public-home-premium__mini-label">Trust</span>
              <h3>{content.calloutTitle}</h3>
              <p>{content.calloutText}</p>
            </div>
          </div>
        </MotionReveal>
      </div>
    </section>
  );
}
